import {
  LicensePaymentStatus,
  type PartyLicenseDto,
} from "Infrastructure/Api/Api";

export const isLicenseActive = ({ paymentStatus }: PartyLicenseDto) =>
  paymentStatus === LicensePaymentStatus.Success;
